export default "__VITE_ASSET__Bz_6QogI__"